import { render, staticRenderFns } from "./CashboxSend.vue?vue&type=template&id=2f590024&"
import script from "./CashboxSend.vue?vue&type=script&lang=js&"
export * from "./CashboxSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports